
<div class="h36"></div>
<div class="content fixTarget" id="content">
  <div class="searchWebBG">
    <div class="searchWebBox sonMod1Box searchWebBox padT20B40">
      <div class="w1224 rela">
        <div class="mianbaoDiv">
          <div class="floatL">您所在的位置：
            <a *ngIf="fromType == '0'" [routerLink]="['/gzEcommerceSearch']" [queryParams]="{userId: userId, userName: userName}">电商商务诚信</a>
            <a *ngIf="fromType == '1'" [routerLink]="['/gzLogisticsSearchComponent']" [queryParams]="{userId: userId, userName: userName}">物流商务诚信</a>
            》企业舆情搜索</div>
          <div class="floatR taRight"><a onclick="history.go(-1);">返回上一页</a></div>
          <div style="clear: both"></div>
        </div>
        <h2 class="titBlue"><div class="floatL"><i></i><span>搜索你想要的企业舆情</span><!--<a href="javascript:void(0);" class="floatL TitBlueGoData">前往监测中心</a>--></div>
          <div class="floatR">
            <div class="RsearchInputBox">
              <div class="indInputBox">
                <nz-input class="indSearchInput" id="keyword" [(ngModel)]="keyword" name="keyword" [nzPlaceHolder]="'请输入企业名称'"
                          (keyup)="inputSomething($event)"  ></nz-input>
                <button class="indSearchBtn" (click)="searchByConditon(1)">查询</button>
                <!--<div [hidden]="keyWord=='' || !showResultDiv" class="result-div">-->
              </div>
            </div>
          </div>
        </h2>
        <!--<div class="advancedSearchBox">
          <div class="clearfix">
            <p class="shaixuan-tj floatL clearfix">
              <span class="blue1">企业高级查询</span>
              &lt;!&ndash;<i class="icon-angle-right"></i>&ndash;&gt;
              <span class="gray2">已选条件：</span>
              &lt;!&ndash;<i class="icon-angle-right"></i>&ndash;&gt;
            </p>
            &lt;!&ndash; <p id="sxbtn" class="shaixuan-btn clearfix"><span><em>收起筛选</em><i class="icon-angle-up"></i></span></p>&ndash;&gt;
            <div class="floatR"><a href="javascript:;" (click)="resetCondition()">重置条件</a></div>
          </div>
          <div id="page-search-store" class="sxcon">
            <div class="search-by by-category relative">
              &lt;!&ndash;<dl class="relative clearfix">
                <dt class="floatL"><a href="/">企业状态</a></dt>
                <dd class="floatL show-con">
                  <a href="/" class="" type="Status">存续</a>
                  <a href="/" class="" type="Status">吊销</a>
                  <a href="/" class="" type="Status">注销</a>
                  <a href="/" class="" type="Status">迁出</a>
                  <a href="/" class="" type="Status">其他</a>
                </dd>
              </dl>&ndash;&gt;
              &lt;!&ndash;<dl class="relative clearfix">
                <dt class="floatL"><a href="/">注册资本</a></dt>
                <dd class="floatL show-con">
                  <a href="/" class="" type="regist_capi">100万以下</a>
                  <a href="/" class="" type="regist_capi">100-500万</a>
                  <a href="/" class="" type="regist_capi">500-1000万</a>
                  <a href="/" class="" type="regist_capi">1000-5000万</a>
                  <a href="/" class="" type="regist_capi">5000万以上</a>
                </dd>
              </dl>&ndash;&gt;
              &lt;!&ndash;<dl class="relative clearfix">
                <dt class="floatL"><a href="/">成立日期</a></dt>
                <dd class="floatL show-con">
                  <a href="/" class="" type="startYear">不足1年</a>
                  <a href="/" class="" type="startYear">1-5年</a>
                  <a href="/" class="" type="startYear">5-10年</a>
                  <a href="/" class="" type="startYear">10-20年</a>
                  <a href="/" class="" type="startYear">20-30年</a>
                  <a href="/" class="" type="startYear">30年以上</a>
                </dd>
              </dl>&ndash;&gt;
              &lt;!&ndash;<dl class="relative clearfix">
                <dt class="floatL"><a href="/">省份地区</a></dt>
                <dd class="floatL show-con">
                  <a href="javascript:;" class="" *ngFor="let p of provinces" type="Province">{{p.name}}</a>
                </dd>
                <dd class="floatL show-more"><h3 class="pointer clearfix"><span>更多</span><i class="icon-angle-down"></i></h3></dd>
              </dl>&ndash;&gt;
              &lt;!&ndash;<dl class="relative clearfix">
                <dt class="floatL"><a href="/">行业门类</a></dt>
                <dd class="floatL show-con">
                  <a href="javascript:;" class="" *ngFor="let industry of industris"  type="Industry">{{industry.industryName}}</a>
                </dd>
                <dd class="floatL show-more"><h3 class="pointer clearfix"><span>更多</span><i class="icon-angle-down"></i></h3></dd>
              </dl>&ndash;&gt;
            </div>
          </div>
          <p id="sxbtn" class="shaixuan-btn clearfix"><span><i class="icon-angle-up"></i></span></p>
        </div>-->

        <div class="BGwhite searchResultBox floatL" style="width: 100%;">
          <div class="filterBox filterBoxWhite">
            <table cellpadding="0" cellspacing="0" border="0" width="100%">
              <tr>
                <td nowrap="nowrap" width="13%">
                  <h4 class="font13" >为您找到 <span class="blue2">{{showTotals}}</span> 条舆情信息</h4>
                </td>
                <td align="right" width="*">
                </td>
                <td align="right" width="1%">
                  <dl class="filterMod">
                    <!--<dd><a href="javascript:;" (click)="exportData()">导出数据</a></dd>-->
                  </dl>
                </td>
              </tr>
            </table>
          </div>

          <table cellpadding="0" cellspacing="0" border="0" width="100%" class="table1">
            <tr>
              <th width="3%"></th>
              <th width="*">舆情信息</th>
              <th width="18%">发布来源</th>
              <!--<th width="10%">监控</th>-->
              <!--<th width="10%">操作</th>-->
            </tr>
            <tr *ngFor="let enterp of enterpList">
              <td>
                <!--<div class="defaultLogo">
                  <img [src]="httpService.getImageUrl(enterp.tmImageUrl)" alt="LOGO" *ngIf="enterp.tmImageUrl != null && enterp.tmImageUrl != ''"/>
                  <img src="../../../assets/images/defaultLogo.png" alt="LOGO" *ngIf="enterp.tmImageUrl == null || enterp.tmImageUrl == ''"/>
                </div>-->
              </td>
              <td>
                <!--新窗口跳转-->
                <div class="spacing1">
                  <h3><a href="{{enterp.url}}" target="_blank">{{enterp.title}}&nbsp;&nbsp;</a></h3>
                  <p><span>企业名称：<span *ngIf="enterp.companyName == null || enterp.companyName ==''">-</span>
                    <span *ngIf="enterp.companyName != null && enterp.companyName !=''" [innerHTML]="enterp.companyName | safeHTML" ></span>
                  </span>
                    <span>发布时间：<span *ngIf="enterp.publishTime == null || enterp.publishTime ==''">-</span>
                      <span *ngIf="enterp.publishTime != null && enterp.publishTime !=''">{{enterp.publishTime | date:'yyyy-MM-dd'}}</span>
                    </span>
                  <p>描述：<span *ngIf="enterp.description == null || enterp.description == '' ">-</span>
                    <span *ngIf="enterp.description != null && enterp.description != '' ">{{enterp.description}}</span></p>
                </div>
              </td>
              <td *ngIf="enterp.source!=null && enterp.source!=''">{{enterp.source}}</td>
              <td *ngIf="enterp.source==null || enterp.source==''">-</td>
              <!--新加的类-->
              <!--<td  class="mgray">
                <span *ngIf="enterp.isAttention == '-1' || (userType != 'person' &&  userType != 'enterprise')">
                  <img src="../../../assets/images/followMgray.png" (click)="attention(enterp)" title="添加关注"/>
                </span>
                <span *ngIf="enterp.isAttention == '0' && (userType == 'person' ||  userType == 'enterprise')" >
                   <img src="../../../assets/images/followMblue.png" (click)="concelAttention(enterp)" title="取消关注"/>
                </span>
                &lt;!&ndash;<span *ngIf="enterp.isSupervise == '-1' && (userType == 'person' ||  userType == 'enterprise')">&ndash;&gt;
                  &lt;!&ndash;<img src="../../../assets/images/underControl0.png" (click)="supervise(enterp)"/>&ndash;&gt;
                &lt;!&ndash;</span>&ndash;&gt;
                &lt;!&ndash;<span *ngIf="enterp.isSupervise == '0'">&ndash;&gt;
                   &lt;!&ndash;<img src="../../../assets/images/underControlHov.png" (click)="unSupervise(enterp)"/>&ndash;&gt;
                &lt;!&ndash;</span>&ndash;&gt;
              </td>-->
            </tr>

          </table>
          <div>
            <app-page [totals]="totals"></app-page>
          </div>
        </div>
        <!--<div class="BGwhite hisSearchBox floatR">
          <div>
            <h3><i></i><span>浏览历史</span></h3>

            <ul>
              <li *ngFor="let h of historyList"><a target="_blank" [routerLink]="['/enterpIntroduction/enterpBasicArchives']" [queryParams]="{companyId: h.COMPANY_ID}" [innerHTML]="h.SEARCH_CONTENT | safeHTML"></a></li>
              <li *ngIf="historyList.length <= 0"><a href="javascript:;">暂无历史记录</a></li>
            </ul>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-news-info/enterp-news-info.component.html